import {
  contactPrivateDataSchema,
  getContactById,
  getPhoneData,
  type UpdateContactPayload,
} from '@aikoa/common'
import { supabase } from '~/lib/supabase'

export async function updateContact(contactPayload: UpdateContactPayload) {
  if (!contactPayload.id) {
    console.error('Contact ID is required for update')
    return null
  }

  const updateData: Record<string, string | boolean | null> = {}

  if (contactPayload.name !== undefined) {
    updateData.name = contactPayload.name
  }

  if (contactPayload.email !== undefined) {
    updateData.email = contactPayload.email || null
  }

  if (contactPayload.phone !== undefined) {
    updateData.phone = formatPhoneNumber(contactPayload.phone) || null
  }

  if (contactPayload.language !== undefined) {
    updateData.language = contactPayload.language
  }

  const { error } = await supabase.from('contacts').update(updateData).eq('id', contactPayload.id)

  if (error) {
    console.error(error)
    return null
  }

  return getContactById(contactPayload.id, supabase)
}

function formatPhoneNumber(phoneNumber: string) {
  if (!phoneNumber) return null
  return getPhoneData(phoneNumber)?.phoneNumber || null
}

export async function deleteContact(contactId: string) {
  const { error } = await supabase.from('contacts').delete().eq('id', contactId)

  if (error) {
    console.error(error)
    return false
  }

  return true
}

export async function updateContactNotes(contactId: string, notes: string) {
  const currentContact = await getContactById(contactId, supabase)

  if (!currentContact) {
    console.error('Contact not found')
    return null
  }

  const currentPrivateData = contactPrivateDataSchema.parse(currentContact.private_data || {})

  const updatedPrivateData = contactPrivateDataSchema.parse({
    ...currentPrivateData,
    notes: notes || null,
  })

  const { error } = await supabase
    .from('contacts')
    .update({ private_data: updatedPrivateData })
    .eq('id', contactId)

  if (error) {
    console.error(error)
    return null
  }

  return getContactById(contactId, supabase)
}
